import request from '@/assets/js/request';
import store from '@/store';

function trendRequest(data) {
    const {mainCpId, subsystem, token, sonCpId, siteId, domainUrl} = store.state.trendConfig || {};
    return request({
        formData: false,
        ...data,
        ...{
            baseURL: '/dataApi',
            headers: {
                mainCpId,
                subsystem,
                token,
                sonCpId,
                siteId,
                domainUrl,
                requestSource : 'systemFrom3Cp'
            },
        },
    });
}

/**
 * 获取数据中心token
 * @param {*} formData
 * @returns
 */
export function getUserInfoToken() {
    return request({
        url: '/org/view/user_info_bigdata.json',
        method: 'GET',
    });
}

/**
 * 查询歌曲数据
 * @param {string} query 查询的关键字
 * @returns
 */
export function fetchTrack(query) {
    return trendRequest({
        url: '/queryParamController/view/queryTrack.json',
        method: 'POST',
        data: {param: query},
    });
}

/**
 * 查询使用量图表数据
 * @param {any} formData
 * @returns
 */
export function fetchUsageAmountChart(formData) {
    return trendRequest({
        url: '/dataDetailReport/view/ajaxQueryDetaildata.json',
        method: 'POST',
        data: formData,
    });
}

/**
 * 获取歌曲列表
 * @param {any} formData
 * @returns
 */
export function fetchSongList(formData) {
    return trendRequest({
        url: '/dataDetailReport/view/ajax_track_table_Data.json',
        method: 'POST',
        data: formData,
    });
}

/**
 * 获取艺人列表
 * @param {any} formData
 * @returns
 */
export function fetchArtistList(formData) {
    return trendRequest({
        url: '/dataDetailReport/view/ajax_artist_table_Data.json',
        method: 'POST',
        data: formData,
    });
}

/**
 * 获取地区列表
 * @param {any} formData
 * @returns
 */
export function fetchCountryList(formData) {
    return trendRequest({
        url: '/dataDetailReport/view/ajax_country_table_Data.json',
        method: 'POST',
        data: formData,
    });
}
